import React from 'react';
import { InfoIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function GiftAidBanner() {
  return <div className="bg-gradient-to-r from-primary to-secondary text-white px-4 py-2 text-sm flex items-center justify-center" data-id="element-334">
      <InfoIcon className="w-4 h-4 mr-2" data-id="element-335" />
      <span data-id="element-336">GiftAid Enabled - Donations Boosted by 25%</span>
      <Link to="/giftaid" className="ml-2 underline font-medium hover:text-white/90 transition-colors" data-id="element-337">
        View Details
      </Link>
    </div>;
}